// import { pollingExcutingJob } from './job';
// import { pollingMessage } from './message';
// import { pollingNotify } from './notify';
import { useNotifyStoreWithOut } from '../modules/notify';

const { fetchUnreadNotifyNum } = useNotifyStoreWithOut();

// const pollings: Array<NodeJS.Timer> = [];

export async function runSchedule() {
  fetchUnreadNotifyNum();
  /**
   * 执行一次任务
   */

  /**
   * 轮询任务
   */
  // 轮询正在执行的任务
  // pollings.push(await pollingExcutingJob());
  // 轮询用户的生成消息
  // pollings.push(await pollingMessage());
  // 轮询用户的通知
  // pollings.push(await pollingNotify());
}

// // 清空正在执行的任务
// export function cleanSchedule() {
//   pollings.forEach((p) => {
//     if (!!p) {
//       p?.stop();
//     }
//   });
// }
